export default class Passo5 {
  constructor(id, listaLinha = [], listaResumo = []) {
    this.id = id;
    this.listaLinha = listaLinha;
    this.listaResumo = listaResumo;
  }
}
